module.exports = __webpack_public_path__ + "static/media/kira.18750640.jpg";